import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintNegativeDecision } from "@/enums/falcon/complaints/falcon-complaint-negative-decision.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint negative decision filter
 */
export const falconComplaintNegativeDecisionFilter: CustomFilter = {
  falconComplaintNegativeDecision(value: any): string {
    value = value.toString() as FalconComplaintNegativeDecision;
    if (value === FalconComplaintNegativeDecision.Scrapping) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintNegativeDecisionScrappingText
      );
    } else if (value === FalconComplaintNegativeDecision.Return) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintNegativeDecisionReturnText
      );
    } else {
      value = "";
    }
    return value;
  }
};
